import { render } from "./B2bNewUserData.vue?vue&type=template&id=29b030fd&scoped=true&lang=pug"
import script from "./B2bNewUserData.vue?vue&type=script&lang=js"
export * from "./B2bNewUserData.vue?vue&type=script&lang=js"

import "./B2bNewUserData.vue?vue&type=style&index=0&id=29b030fd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b030fd"]])

export default __exports__